import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Route, NavLink, Redirect } from 'react-router-dom';

import Header from './header';
import Library from './library';
import Albums from './albums';
import MyHiFives from './my-hi-fives';
import NewReleases from './new-releases';

@inject('artistStore', 'userStore', 'songsStore')
@observer
export default class MyMusic
extends React.Component {
	constructor (props) {
		super(props);
		this.fetchData();
	}

	// Kick off the fetches every mount. Loading.js already fetches the profile
	// pre-mount, but subs and songs haven't been loaded anywhere else, and
	// without them LibraryItem's SongList silently renders null. Each
	// fetchIfEmpty short-circuits when already populated, so calling every
	// time is cheap.
	fetchData () {
		const { userStore, artistStore, songsStore } = this.props;

		if (_.isEmpty(userStore.items)) {
			userStore.fetchProfile();
		}
		artistStore.fetchIfEmpty();
		songsStore.fetchIfEmpty();
	}

	render() {
		const { userStore, artistStore, songsStore } = this.props;

		if (userStore.isLoading || artistStore.isLoading || songsStore.isLoading) {

			return null;
		}

		const member = userStore.getLoggedInUser();

		if (_.isEmpty(member)) {

			return null;
		}

		const renderComp = (Comp) => (
			() => ( <Comp member={ member } /> )
		);

		return (
			<Fragment>
				<div className="grid-x header-grid margin-bottom-1">
					<div className="cell small-12">
						<Header member={ member } />
					</div>
				</div>

				<div className="grid-x grid-padding-x" style={{width: '99.1vw'}}>
					<div className="cell small-12">
						<Route exact
							path="/my-music"
							render={
								() => ( <Redirect to="/my-music/library" /> )
							}
						/>
						<Route
							path="/my-music/library"
							render={ renderComp(Library) }
						/>
						<Route
							path="/my-music/albums"
							render={ renderComp(Albums) }
						/>
						<Route
							path="/my-music/my-hi-fives"
							render={ renderComp(MyHiFives) }
						/>
						<Route
							path="/my-music/new-releases"
							render={ renderComp(NewReleases) }
						/>
					</div>
				</div>
			</Fragment>
		);
	}
}
